import {
  Radar, Sun, Clock, Gauge, SlidersHorizontal, TrendingDown, BarChart3, Globe,
  LayoutGrid, LocateFixed, Activity, Bell, Boxes, KeyRound, RefreshCcw, ShieldCheck,
  Lock, Lightbulb, Network, Expand, Leaf, Settings2, LampCeiling, Cpu, Trees,
  ToggleLeft, Plug, RadioTower, Building2, Store, Factory, Warehouse, LampDesk, Home,
  ClipboardList, Wrench, Smartphone, TrendingUp, Zap,
} from "lucide-react";

export const CAPABILITY_ICONS = {
  "Occupancy / Vacancy": Radar,
  "Daylight Harvesting": Sun,
  "Scheduling": Clock,
  "Bi-Level Dimming": Gauge,
  "Continuous Dimming": SlidersHorizontal,
  "High-End Trim": TrendingDown,
  "Energy Monitoring": BarChart3,
  "Remote Access": Globe,
  "Zoning": LayoutGrid,
  "Individual Luminaire Addressability": LocateFixed,
  "Real-Time Monitoring": Activity,
  "Alerts": Bell,
  "Asset Management": Boxes,
  "User Permissions": KeyRound,
  "Firmware Updates": RefreshCcw,
  "Fail-Safe Operation": ShieldCheck,
  "Secure Connectivity": Lock,
};

export const WHY_ICONS = {
  Smarter: Lightbulb,
  Connected: Network,
  Scalable: Expand,
  Efficient: Leaf,
  Manageable: Settings2,
  Secure: ShieldCheck,
};

export const APP_ICONS = {
  office: Building2,
  commercial: Store,
  industrial: Factory,
  "high-bay": Warehouse,
  "low-bay": LampDesk,
  outdoor: Trees,
  residential: Home,
};

export const ECO_ICONS = {
  Indoor: LampCeiling,
  Node: Cpu,
  Outdoor: Trees,
  "Wall Switch": ToggleLeft,
  "Wall Outlet": Plug,
  "Long Range Extender": RadioTower,
};

export const SOLUTION_ICONS = {
  "energy-optimization": Leaf,
  "smart-lighting-automation": Zap,
  "remote-management": Globe,
  "large-facility-control": Network,
  "building-performance": BarChart3,
};

export const STEP_ICONS = [ClipboardList, Settings2, Wrench, Smartphone, Activity, TrendingUp];
